<template>
  <div>

    <v-card>
      <v-toolbar
        color="secondary"
        dark
      >
        <v-toolbar-side-icon><v-icon>folder</v-icon></v-toolbar-side-icon>
        <v-toolbar-title>
          {{$tc('app.group', 2)}}
        </v-toolbar-title>
        <v-spacer></v-spacer>

        <transition
          enter-active-class="animated bounceIn"
          leave-active-class="animated bounceOut"
        >

        <span
          v-if="selectedRows !== undefined && selectedRows.length !== 0"
        >
          <!-- mass delete button -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                v-on="on"
                @click.prevent="massDeleteModalVisible = true"
                icon
              >
                <v-icon>delete</v-icon>
              </v-btn>
            </template>
            <span>{{ $tc('group.deleteGroup', selectedRows.length) }}</span>
          </v-tooltip>

        </span>
        </transition>

      </v-toolbar>
      <v-card-text>
        <v-progress-linear
          v-show="loading"
          slot="progress"
          color="accent"
          indeterminate
        ></v-progress-linear>
        <vuetable
          :data="groups"
          ref="vuetable"
          :fields="fields"
          :css="css.table"
          @vuetable:loading="onLoading"
          @vuetable:loaded="onLoaded"
        >
        <div slot="actions-slot" slot-scope="props">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
            <v-btn
              @click="showAssignGroupDialog(props.rowData)"
              flat
              icon
            >
              <v-badge color="green" :overlap="true">
                <v-icon>playlist_add</v-icon>
                <template v-if="parseInt(props.rowData.boxes_assigned) > 0"  v-slot:badge>
                  <small>
                    {{ (props.rowData.boxes_assigned > 99) ? "99+" : props.rowData.boxes_assigned }}
                  </small>
                </template>
              </v-badge>
            </v-btn>

              <v-btn
                v-if="$store.getters.hasPermission('edit_organization_boxes')"
                v-on="on"
                @click="showDeleteGroupDialog(props.rowData)"
                flat
                icon
              >
                <v-icon>delete</v-icon>
              </v-btn>
            </template>
            <span>{{ $tc('group.deleteGroup', 1) }}</span>
          </v-tooltip>
        </div>
        </vuetable>
      </v-card-text>

        <v-card-actions>
          <vuetable-pagination ref="pagination"
            :css="css.pagination"
          ></vuetable-pagination>
        </v-card-actions>
      </v-card>
      <v-dialog
        v-if="$store.getters.hasPermission('edit_organization_boxes')"
        v-model="addModalVisible"
        max-width="500px"
      >
        <v-card>
          <v-card-title primary-title>
            <h3 class="headline">{{ $tc("group.createGroup", 1) }}</h3>
          </v-card-title>
          <v-card-text>
            <v-container fluid grid-list-xl>
              <v-layout row wrap>
                <v-flex xs12>
                  <v-text-field
                    v-model="newGroup.name"
                    v-validate="{ required: true }"
                    data-vv-name="name"
                    name="name"
                    prepend-icon="font_download"
                    type="text"
                    :label="$t('general.name')"
                    :error="errors.has('name')"
                    :error-messages="errors.collect('name')"
                    single-line
                    required
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              @click="addModalVisible = false"
              flat
            >{{ $t("general.close") }}</v-btn>
            <v-btn
              color="primary"
              @click.prevent="createGroup()"
            >{{ $t("general.create") }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog
        v-if="$store.getters.hasPermission('edit_organization_boxes')"
        v-model="assignGroupModalVisible"
        max-width="500px"
        scrollable
      >
        <v-card>
          <v-card-title primary-title>
            <h3 class="headline">{{ $tc("group.assignGroup", 1) }}</h3>
          </v-card-title>
          <v-card-text>
            <v-list>
              <v-list-tile>
                <v-list-tile-action>
                  <v-checkbox
                    v-model="allBoxesSelected"
                  ></v-checkbox>
                </v-list-tile-action>
              </v-list-tile>
              <v-list-tile
                v-for="box in boxes"
                :key="box.id"
              >
                <v-list-tile-action>
                  <v-checkbox
                    v-model="boxesToAssign"
                    :value="box.id"
                  ></v-checkbox>
                </v-list-tile-action>
                <v-list-tile-content>
                  <v-list-tile-title>{{box.name}} ({{box.note}})</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              @click="assignGroupModalVisible = false"
              flat
            >{{ $t("general.close") }}</v-btn>
            <v-btn
              @click.prevent="assignGroupBoxes()"
              color="primary"
            >{{ $t("general.assign") }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- confirmation dialog: delete one group -->
      <v-dialog
        v-if="$store.getters.hasPermission('edit_organization_boxes')"
        v-model="deleteModalVisible"
        max-width="500px"
      >
        <v-card>
          <v-card-title primary-title>
            <h3 class="headline">{{ $tc("group.deleteGroup", 1) }}</h3>
          </v-card-title>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              @click="deleteModalVisible = false"
              flat
            >{{ $t("general.close") }}</v-btn>
            <v-btn
              @click.prevent="deleteGroup()"
              color="accent"
            >{{ $t("general.delete") }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-speed-dial
        v-if="$store.getters.hasPermission('edit_organization_boxes')"
        fixed
        bottom
        right
        open-on-hover
      >
        <v-btn
          slot="activator"
          color="accent"
          dark
          fab
          hover
          @click="addModalVisible = true"
        >
          <v-icon>add</v-icon>
        </v-btn>
      </v-speed-dial>
  </div>
</template>
<style>
.custom-fields-table {
width: 60%;
}
</style>
<script>
import axios from 'axios';
import VueTableMaterialDesignCheckgroup from '@/components/generic/VueTableMaterialDesignCheckbox.vue';
import VueTableMixin from '@/components/generic/VueTableMixin';

export default {
mixins: [
  VueTableMixin,
],
  data() {
      return {
        groups: [],
        newGroup: {
          name: '',
        },
        fields: [
          {
            titleClass: 'text-xs-left',
            dataClass: 'text-xs-left',
            name: VueTableMaterialDesignCheckgroup,
          },
          {
            title: 'ID',
            titleClass: 'text-xs-left',
            dataClass: 'text-xs-left',
            name: 'id',
            sortField: 'id',
          },
          {
            title: this.$i18n.t('general.name'),
            titleClass: 'text-xs-left',
            dataClass: 'text-xs-left',
            name: 'name',
            sortField: 'name',
          },
          {
            title: this.$i18n.tc('general.action', 2),
            titleClass: 'text-xs-center',
            dataClass: 'text-xs-center',
            name: 'actions-slot',
          },
        ],
        css: {
          table: {
            tableClass: 'v-table v-datatable custom-fields-table',
            ascendingIcon: 'mdi mdi-sort-ascending',
            descendingIcon: 'mdi mdi-sort-descending',
          },
        },
        sortOrder: [
          { field: 'id', sortField: 'id', direction: 'asc' },
          { field: 'name', sortField: 'name', direction: 'asc' },
        ],
        deleteModalVisible: false,
        addModalVisible: false,
        allGroupesSelected: false,
        currentGroup: null,
        currentGroupesCount: {
          activated_groups_count: 0,
        },
        assignGroupModalVisible: false,
        boxes: [],
        boxesToAssign: [],
        allBoxesSelected: false,
      };
  },
  methods: {
    getAllGroups() {
      const vm = this;

      axios.get(`${window.api_url}api/groups`, {

      })
        .then((response) => {
          this.groups = response.data;
        })
        .catch((error) => {
          vm.$toasted.show(error.response.data.message, { duration: 3000, singleton: true, type: 'error' });
        });
    },
    createGroup() {
      const vm = this;

      axios.post(`${window.api_url}api/group`, {
        name: this.newGroup.name,
      })
        .then(() => {
          vm.addModalVisible = false;
          vm.getAllGroups();
        })
        .catch((error) => {
          vm.$toasted.show(error.response.data.message, { duration: 3000, singleton: true, type: 'error' });
        });
    },
    showDeleteGroupDialog(group) {
      this.currentGroup = group;
      this.deleteModalVisible = true;
    },
    deleteGroup() {
      this.deleteModalVisible = false;
      this.deleteItem('group', this.currentGroup.id);

      const vm = this;
      setTimeout(() => vm.getAllGroups(), 1000);
    },
    showAssignGroupDialog(group) {
      const boxarray = [];
      this.currentGroup = group;
      const { boxes } = group;
      boxes.forEach((value) => {
          boxarray.push(value.id);
      });
      this.boxesToAssign = boxarray;
      this.assignGroupModalVisible = true;
    },
    assignGroupBoxes() {
      const vm = this;

      vm.assignGroupModalVisible = false;

      axios.post(`${this.apiUrl}api/group/${this.currentGroup.id}/boxes`, {
        ids: this.boxesToAssign,
      })
        .then(() => {
        vm.$toasted.show('Boxes Assigned', { duration: 3000, singleton: true, type: 'success' });
        })
        .catch((error) => {
          vm.$toasted.show(error,
            { duration: 3000, singleton: true, type: 'error' });
          vm.assignPlaylistModalVisible = false;
        });
    },
  },
  mounted() {
    const vm = this;
    this.getAllGroups();

    this.$watch('allBoxesSelected', () => {
      if (this.allBoxesSelected) {
        this.boxesToAssign = this.boxes.map((box) => box.id);
      } else {
        this.boxesToAssign = [];
      }
    });

    axios.get(`${this.apiUrl}api/boxes`, {
      params: {
        paginate: false,
      },
    })
      .then((response) => {
        vm.boxes = response.data.data;
      })
      .catch((error) => {
        vm.$toasted.show(error.response.data.message, { duration: 3000, singleton: true, type: 'error' });
      });
  },
};
</script>

<style scoped>
.v-input--is-disabled:hover {
  cursor: pointer;
}
</style>
